/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Image } from 'antd';
import { Link } from 'react-router-dom';
import logo from '../assets/logos/logo.png';

type Props = {
  className?: string;
  path?: string | number;
};
function Logo({ className, path = -1 }: Props) {
  return (
    <Link
      to={path as any}
      className={'w-auto flex items-center z-40 '.concat(className!)}
    >
      <Image alt="logo" src={logo} preview={false} className="max-w-[80px]" />
    </Link>
  );
}

export default Logo;
